import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginProviderType } from '../state/types';
import { UserSettingsStorage } from '../storage/user.settings.storage';

type EnvironmentKey = keyof typeof environment;
type EnvironmentValue<T extends EnvironmentKey> = (typeof environment)[T];

@Injectable({
  providedIn: 'root',
})
export class ConfigurationFacade {
  private environment = environment;
  private uss = new UserSettingsStorage();

  getValueFor<K extends EnvironmentKey>(key: K): EnvironmentValue<K> {
    return this.environment[key];
  }

  getServerUrl(resourceEndpoint: string): string {
    if (resourceEndpoint.startsWith('http')) {
      return resourceEndpoint;
    }
    if (this.usingLegacyLogin()) {
      return `${this.getValueFor('serverUrl').withLegacy}${resourceEndpoint}`;
    }
    return `${this.getValueFor('serverUrl').withSSO}${resourceEndpoint}`;
  }

  private usingLegacyLogin(): boolean {
    return this.uss.loadSetting(UserSettingsStorage.LOGIN_PROVIDER) === LoginProviderType.LEGACY;
  }
}
